import React from 'react';
import { MapPin, ExternalLink, Navigation } from 'lucide-react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

delete L.Icon.Default.prototype._getIconUrl;

const customerIcon = new L.DivIcon({
  className: 'cust-detail-marker',
  html: `<div style="width:26px;height:26px;border-radius:50% 50% 50% 0;background:#3b82f6;transform:rotate(-45deg);border:3px solid white;box-shadow:0 2px 8px rgba(0,0,0,0.4);"></div>`,
  iconSize: [26, 26],
  iconAnchor: [13, 26],
});

const CustomerLocationCard = ({ customer }) => {
  const lat = parseFloat(customer?.latitude);
  const lng = parseFloat(customer?.longitude);
  const hasValidCoords = !isNaN(lat) && !isNaN(lng) && lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180;

  if (!hasValidCoords) {
    return (
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
            <MapPin className="text-indigo-600" size={20} /> Lokasi Pelanggan
          </h3>
        </div>
        <div className="flex flex-col items-center justify-center py-12 text-gray-400 gap-2">
          <MapPin className="w-12 h-12 text-gray-300" />
          <p className="text-sm">Koordinat lokasi belum diisi</p>
          <p className="text-xs">Edit pelanggan untuk menambahkan latitude & longitude</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-4">
        <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <MapPin className="text-indigo-600" size={20} /> Lokasi Pelanggan
        </h3>
        <div className="flex gap-3">
          <a
            data-testid="customer-detail-google-maps"
            href={`https://www.google.com/maps?q=${lat},${lng}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-blue-600 hover:text-blue-700 hover:underline flex items-center gap-1"
          >
            <ExternalLink className="w-3 h-3" /> Google Maps
          </a>
          <a
            data-testid="customer-detail-directions"
            href={`https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-emerald-600 hover:text-emerald-700 hover:underline flex items-center gap-1"
          >
            <Navigation className="w-3 h-3" /> Petunjuk Arah
          </a>
        </div>
      </div>
      <div className="text-xs text-gray-500 mb-2 font-mono">
        {lat.toFixed(6)}, {lng.toFixed(6)}
      </div>
      <div className="rounded-lg overflow-hidden border border-gray-200" style={{ height: '320px' }}>
        <MapContainer center={[lat, lng]} zoom={16} style={{ height: '100%', width: '100%' }}>
          <TileLayer
            attribution='&copy; OpenStreetMap'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={[lat, lng]} icon={customerIcon}>
            <Popup>
              <div className="text-sm">
                <div className="font-bold">{customer.name}</div>
                {customer.address && <div className="text-xs text-gray-600">{customer.address}</div>}
              </div>
            </Popup>
          </Marker>
        </MapContainer>
      </div>
    </div>
  );
};

export default CustomerLocationCard;
